/* eslint-disable react-hooks/exhaustive-deps */
import useDataTable from '../../../hooks/useDataTable';

export default function ShowTable({ data }) {
    const columns = [
        {
            name: 'Item Name',
            selector: (row) => row.drug_name,
            sortable: true,
            wrap: true,
            grow: 4,
        },
        {
            name: 'Supply Qty',
            selector: (row) => row.approved_supply_qty,
            sortable: true,
        },
        {
            name: 'Received Qty',
            selector: (row) => row.received_qty,
            sortable: true,
        },
        {
            name: 'Rejected Qty',
            selector: (row) => row.rejected_qty,
            sortable: true,
        },
        {
            name: 'Rejected Reason',
            selector: (row) => row.rejected_reason,
            sortable: true,
            width: '250px',
        },
    ];

    const search_column = {
        drug_name: 'Name',
    };
    return useDataTable({ columns, data, search_column, pagination: false });
}
